<template>
  <!-- 邀请进度 -->
  <div v-if="bodyShow" class="progress-main">
    <!-- header -->
    <div class="pr_top">
      <div class="pt_t clearfix">
        <div class="pt_l">
          <img :src="user.headimgurl" alt="" />
          <div class="pl_r">
            <h2>{{user.nickname}}</h2>
            <h2 v-if="promoter.level==2">{{promoter.role}}</h2>
            <a v-else @click="level_show=true">升级</a>
          </div>
        </div>
        <router-link :to="{path:'/recruiting',query:{'course_id':$route.query.course_id}}" class="pt_r">
          招募推广大使 >
        </router-link>
      </div>
      <div class="pt_m">
        <h2>累计收益（元）</h2>
        <h2><b>{{promoter.total_fee}}</b><span @click="$router.push('/my_account')">去提现 >></span></h2>
      </div>
      <div class="pt_ul clearfix">
        <ul>
          <li>
            <a @click="promoter.view_count==0?alert_show_c(1):$router.push({
                            path:'/invitation_list',
                            query:{
                                course_id:$route.query.course_id,
                                tab:0,
                                urlfrom:'check_invite'
                            }
                        })">
              <h2>查看的好友(人)</h2>
              <h1>{{promoter.view_count}}</h1>
            </a>
          </li>
          <li>
            <a @click="promoter.buy_count==0?alert_show_c(2):$router.push({
                            path:'/invitation_list',
                            query:{
                                course_id:$route.query.course_id,
                                tab:1,
                                urlfrom:'friend_apply'
                            }
                        })">
              <h2>累计推广订单(笔)</h2>
              <h1>{{promoter.buy_count}}</h1>
            </a>
          </li>
          <li>
            <a @click="promoter.downline_count==0?alert_show_c(3):$router.push('/promote_lower')">
              <h2>我的下级(人)</h2>
              <h1>{{promoter.downline_count}}</h1>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!--  -->
    <div class="progress-content">
      <!--  -->
      <div class="progress-btn clearfix">
        <button class="clearfix" @click="$router.push({
                    path:'/training_money',
                    query:{
                        course_id:$route.query.course_id,
                        type: 0
                    }
                })">
          <img src="@a/pr_s1.png" alt="" />
          <div class="pr_sr">
            <h2>推广课程</h2>
            <h3>客户越多赚钱越快</h3>
          </div>
        </button>
        <button class="clearfix poster" @click="$router.push({
                    path:'/training_money',
                    query:{
                        course_id:$route.query.course_id,
                        type: 100
                    }
                })">
          <img src="@a/pr_s2.png" alt="" />
          <div class="pr_sr">
            <h2>发展下级</h2>
            <h3>邀请好友一起赚钱</h3>
          </div>
        </button>
      </div>
      <div class="pr_bg" @click="card_show=true">
        立即获得{{promoter.first_fee}}元现金
      </div>
      <!-- 排行榜列表 -->
      <div class="ranking-list">
        <div class="ranking-head">
          <img src="@a/training_ranking.png" alt="">
          <h2>本期邀请排行榜前10名</h2>
        </div>
        <!--  -->
        <van-tabs :class="['tab','clearfix',tab_poster===1?'on':'']" v-model="tab_poster">
          <van-tab title="排行榜">
            <div v-for="(item,index) in promoterList" :key="index" class="list">
              <!-- 前三名奖牌 -->
              <img class="index" v-if="index==0" src="@a/medal1.png" alt="">
              <img class="index" v-if="index==1" src="@a/medal2.png" alt="">
              <img class="index" v-if="index==2" src="@a/medal3.png" alt="">
              <div v-if="index>2" class="index">{{index+1}}</div>
              <!--  -->
              <img class="headimg" :src="item.headimgurl " alt="">
              <div class="userinfo text-ellipsis">
                <h2>{{item.nickname}}</h2>
                <small>成功邀请{{item.buy_count }}名好友</small>
              </div>
              <div class="money pull-right clearfix">
                获<span>{{item.total_fee }}</span>元红包
              </div>
            </div>
          </van-tab>
          <van-tab class="clearfix" title="我的邀请">
            <div v-if="item.state==1" v-for="(item,index) in invitation_list" :key="index" class="invitation-list">
              <img :src="item.headimgurl" alt="">
              <div class="nickname text-ellipsis">{{item.nickname}}</div>
              <div class="invitation-right pull-right clearfix">{{item.pay_time}} 报名</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 分享链接弹窗 -->
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <van-popup v-model="level_show" position="bottom" class="level_pop">
      <h3>*成功<span v-if="promote_count!=0">推广{{promote_count}}笔订单</span><span v-if="promote_count!=0&&invite_count!=0">且</span><span v-if="invite_count!=0">邀请{{invite_count}}名下级</span>，自动升级为高级推广员，佣金上浮33%</h3>
      <h2>系统检测到您已成功<b v-if="promote_count!=0">推广<span>{{promoter.buy_count}}笔</span>订单</b><b v-if="promote_count!=0&&invite_count!=0">和</b><b v-if="invite_count!=0">邀请<span>{{promoter.downline_count}}名</span>下级</b><br/>还差一点点哦，加油加油哦</h2>
      <a @click="level_show=false">知道了</a>
    </van-popup>
    <van-popup class="pub_alert" v-model="alert_show">
      <div class="confirm_box">
        <h2>提示</h2>
        <p v-if="alert_show_n==1">亲，暂无好友查看哦</p>
        <p v-else-if="alert_show_n==2">亲，暂无成交订单哦</p>
        <p v-else-if="alert_show_n==3">亲，暂无好友建立合作关系哦</p>
        <p v-else-if="alert_show_n==4">恭喜你与好友【{{parent_nickname}}】已绑定关系快去赚钱吧</p>
        <div class="btn_group">
          <a @click="alert_show=false">知道了</a>
        </div>
      </div>
    </van-popup>
    <!-- 引入意见反馈 -->
    <public-feedback></public-feedback>
  </div>
</template>
<script>
import {
  inviteProgress,
  inviteList
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
import publicFeedback from "@c/training/public-feedback"
export default {
  data() {
      return {
        card_show: false,
        bodyShow: false,
        promoter: {},
        promoterList: [],
        tab_poster: 0,
        invitation_list: [],
        type_obj: {},
        course_id: "",
        user: {},
        level_show: false,
        alert_show: false,
        alert_show_n: null,
        parent_nickname: '',
        promoter: '',
        promote_count: '',
        invite_count: '',
      }
    },
    components: {
      publicFeedback
    },
    methods: {
      alert_show_c(num) {
        this.alert_show_n = num;
        this.alert_show = true;
      },
      pullData() {
        // 排行榜
        let arr1 = inviteProgress({
          course_id: this.$route.query.course_id
        });
        // 邀请
        let arr2 = inviteList({
          course_id: this.$route.query.course_id
        });

        Promise.all([arr1, arr2]).then((data) => {
          if (data[0].code && data[0].code === 10002) {
            this.$toast(data[0].msg);
            return
          }
          if (data[1].code && data[1].code === 10002) {
            this.$toast(data[1].msg);
            return
          }

          this.user = data[0].user;
          this.promoter = data[0].promoter;
          this.promoterList = data[0].promoterList;
          this.parent_nickname = data[0].parent_nickname;
          this.promote_count = data[0].promote_count;
          this.invite_count = data[0].invite_count;
          this.invitation_list = data[1].buy;
          this.bodyShow = true;
          this.$route.query.course_type == 'show' ? this.alert_show_c(4) : '';
          this.type_obj = {
            nickname: data[1].user.nickname,
            train_name: data[1].course.name,
            train_id: data[1].course.id,
            share: data[1].user.id
          };
          shareCon("training", this, this.type_obj);
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.confirm_box {
  h2 {
    padding-bottom: 12px;
    font-size: 32px;
    color: #333;
    font-weight: bold;
  }
  p {
    margin-bottom: 30px;
    font-size: 26px;
    color: #333;
    text-align: center;
    padding: 0 20px;
    line-height: 40px;
  }
  .btn_group {
    a {
      width: 100%;
      font-size: 34px;
      color: #EB5032;
      text-align: center;
    }
  }
}

.pr_top {
  background: url(../../../assets/pr_t.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 414px;
  padding: 0 30px;
  .pt_t {
    padding: 20px 0;
    border-bottom: 2px solid rgba(246, 226, 217, 1);
    .pt_l {
      float: left;
      img {
        width: 60px;
        margin-right: 20px;
        border-radius: 50%;
        vertical-align: baseline;
      }
      .pl_r {
        display: inline-block;
        h2 {
          font-size: 26px;
          color: #fff;
          margin-bottom: 8px;
          line-height: 30px;
        }
        a {
          width: 98px;
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 16px;
          font-size: 24px;
          color: #fff;
          text-align: center;
          line-height: 32px;
          display: inline-block;
        }
      }
    }
    a.pt_r {
      float: right;
      display: inline-block;
      width: 231px;
      line-height: 60px;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      border-radius: 30px;
      font-size: 28px;
      color: #F57F17;
      margin-top: 6px;
    }
  }
  .pt_m {
    padding: 10px 0;
    h2 {
      color: #fff;
      font-size: 28px;
      line-height: 40px;
      margin-top: 20px;
      b {
        font-size: 60px;
        line-height: 40px;
        margin-right: 30px;
      }
    }
  }
  .pt_ul {
    margin-top: 10px;
    ul{
      display: flex;
      justify-content: space-between;
      li {
        text-align: center;
        a {
          display: block;
          width: 100%;
          height: 100%;
          h2 {
            color: #fff;
            font-size: 28px;
            line-height: 40px;
          }
          h1 {
            color: #fff;
            font-size: 48px;
            line-height: 40px;
            margin-top: 20px;
          }
        }
      }
    }
    ul li:last-child {
      margin-right: 0
    }
  }
}

.level_pop {
  width: 100%;
  height: 800px;
  padding-top: 56px;
  text-align: center;
  h3 {
    font-size: 24px;
    color: #333;
  }
  h2 {
    margin-top: 44px;
    line-height: 40px;
    color: #333;
    font-size: 32px;
    span {
      color: #EB5032;
    }
  }
  a {
    display: block;
    width: 100%;
    line-height: 98px;
    background-color: #EB5032;
    text-align: center;
    font-size: 34px;
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.progress-main {
  .progress-head {
    background: linear-gradient(to right, #F57F17, #EB5032);
    color: #fff;
    text-align: center;
    padding: 32px 30px 26px;
    h2.title {
      margin-bottom: 32px;
      line-height: 1;
      font-size: 36px;
    }
    .box {
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      padding: 30px;
      width: 100%;
      div {
        width: 33.33%;
        display: inline-block;
        border-right: 4px solid #F57F17;
        padding: 28px 0;
        h2 {
          font-size: 48px;
          color: #EB5032;
          line-height: 1;
          word-wrap: break-word;
          margin-bottom: 20px;
          small {
            font-size: 32px;
          }
        }
        a {
          font-size: 28px;
          color: #666666;
          line-height: 1;
          img {
            margin-left: 6px;
            width: 26px;
            height: 20px;
          }
        }
        a.on {
          color: #333;
        }
      }
      div:last-child {
        border-right: 0px;
      }
    }
    p {
      margin-top: 30px;
      font-size: 26px;
    }
  }
}

//
.progress-content {
  padding: 40px 30px 60px;
  .progress-btn {
    button {
      border-radius: 8px;
      width: 320px;
      background-color: #fff;
      padding: 40px 20px;
      float: left;
      border: none;
      img {
        width: 64px;
        float: left;
      }
      .pr_sr {
        float: right;
        text-align: left;
        display: inline-block;
        h2 {
          font-size: 34px;
          color: #333;
          line-height: 30px;
          font-weight: bold;
        }
        h3 {
          font-size: 26px;
          color: #333;
          line-height: 30px;
          margin-top: 6px;
        }
      }
    }
    .poster {
      float: right;
    }
  }
  .pr_bg {
    width: 100%;
    margin-top: 30px;
    background: url(../../../assets/pr_bg.png) no-repeat top center;
    background-size: cover;
    height: 180px;
    color: #fff;
    padding-top: 97px;
    padding-left: 315px;
    font-size: 30px;
  }
  // 排行榜列表
  .ranking-list {
    overflow: hidden;
    border-radius: 8px;
    margin-top: 60px;
    box-shadow: 0px 5px 8px 0px rgba(51, 51, 51, 0.5);
    .ranking-head {
      background-color: #EB5032;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      color: #fff;
      text-align: center;
      padding: 22px 30px 40px;
      img {
        width: 246px;
        height: 226px;
      }
      h2 {
        font-size: 36px;
        line-height: 1;
        margin-top: 24px;
      }
    }
  }
  .tab {
    z-index: 0;
    .list {
      background-color: #fff;
      padding: 14px 30px;
      border: 2px solid rgba(225, 225, 225, 1);
      .index {
        width: 52px;
        font-size: 40px;
        color: #333;
        display: inline-block;
        vertical-align: middle;
      }
      img.headimg {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-left: 20px;
      }
      .userinfo {
        display: inline-block;
        vertical-align: middle;
        width: 240px;
        margin-left: 10px;
        h2 {
          font-size: 26px;
          color: #333;
        }
        small {
          font-size: 26px;
          color: #999;
        }
      }
      .money {
        line-height: 60px;
        color: #333;
        font-size: 28px;
        span {
          font-size: 36px;
          color: #EB5032;
          margin: auto 10px auto;
        }
      }
    }
    .list:last-child {
      border: 0;
    }
    //
    .invitation-list {
      padding: 17px 30px;
      background-color: #fff;
      color: #333;
      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .nickname {
        display: inline-block;
        vertical-align: middle;
        width: 240px;
        font-size: 26px;
      }
      .invitation-right {
        line-height: 60px;
      }
    }
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
<style lang="scss">
//
.tab {
  .van-tabs__wrap .van-tabs__nav {
    background-color: #9E2D17;
    color: #fff;
    .van-tab,
    .van-tab--active {
      color: #fff;
    }
    .van-tabs__line {
      width: 0px !important;
      background-color: transparent;
      left: 25%;
      transform: translateX(-50%) !important;
      height: 0px;
      border-width: 16px;
      border-style: solid;
      border-color: transparent transparent #fff transparent;
    }
  }
}

.tab.on .van-tabs__wrap .van-tabs__nav {
  .van-tabs__line {
    left: 75%;
  }
}
</style>
